export default __webpack_public_path__ + "static/media/inactiveHome.9976e778.svg";